import contactsService from '@/app-domains/contacts/contacts.service'
import contactslabelsService from '@/app-domains/contactslabels/contactslabels.service'
import { Button } from '@/components/Button/Button'
import ToastService from '@/components/Toast/Toast.service'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import store from '@/core/store'
import { useState } from 'react'
import ContactCard from './ContactCard/ContactCard'
import './ContactList.scoped.sass'

// eslint-disable-next-line
export function ContactList (props) {
  // eslint-disable-next-line
  const [currentLabel, setCurrentLabel] = useState({name: 'Contacts'} || contactslabelsService.getCurrentLabel())
  const [labelContacts, setLabelContacts] = useState(Object.values(contactsService.getAllStoredContacts()))
  const [chosenContact, setChosenContact] = useState(undefined)
  const [markedContacts, setMarkedContacts] = useState([])

  useRenderEvent(['CONTACT_LIST:UPDATED'], async (contactList) => {
    if (!contactList) {
      contactList = Object.values(contactsService.getAllStoredContacts())
    }
    setLabelContacts(
      contactList
    )
  })

  useRenderEvent(['CONTACT_LIST:FILTER_UPDATED'], ({ filter, contacts }) => {
    setCurrentLabel(filter)
    setLabelContacts(contacts)
  })

  useRenderEvent(['CONTACT_LIST:FOCUS'], (contact) => {
    setChosenContact(contact)
  })

  function triggerContactViewUpdate (contact) {
    store.commit('CONTACT_VIEW:UPDATED', contact)
    setChosenContact(contact)
  }

  function markContact (contact) {
    let newMarked = markedContacts

    if (newMarked.find(con => contact.id === con.id)) newMarked = newMarked.filter(con => contact.id !== con.id)
    else newMarked.push(contact)

    setMarkedContacts([...newMarked])
  }

  async function deleteContacts () {
    ToastService.show({
      type: 'info',
      title: 'Action in progress',
      message: 'Deleting contacts',
    })
    
    for (const contact of markedContacts) {
      await contactsService.removeContact(contact)
    }
    store.commit('CONTACT_VIEW:UPDATED')
    store.commit('CONTACT_LIST:UPDATED', Object.values(contactsService.getAllStoredContacts()))
    setMarkedContacts([])

    ToastService.show({
      type: 'success',
      title: 'Action successful',
      message: 'Contacts deleted',
    })
  }
 
  const visibleContacts = (labelContacts || []).filter(c => c.emails?.length > 0)

  return (
    <div className="contacts-list">
      <div className="menu-top">
        <div className="menu-top-label">
          {currentLabel.name.toUpperCase()} ({visibleContacts.length})
        </div>
      </div>
      <ul className="contacts-buttons">
        {visibleContacts.map((contact) => <li key={contact.id} className="contacts-buttons-profile">
          <ContactCard
            contact={contact}
            setChosenContact={setChosenContact}
            isActive={chosenContact && contact.id === chosenContact.id}
            selectContact={() => triggerContactViewUpdate(contact)}
            markContact={markContact}
          />
        </li>)}
      </ul>
      {markedContacts.length > 1 && <div className='edit-contacts-button'>
        <Button content={`Delete ${markedContacts.length} contacts`} click={deleteContacts} />
      </div>}
    </div>
  )
}
